import type { CollectorChannel } from '@detect/shared';

/** The release channels a collector can follow, in the words an admin sees (#171). */
export const CHANNEL_OPTIONS: readonly { value: CollectorChannel; label: string; hint: string }[] = [
  { value: 'stable', label: 'Stable', hint: 'Follows the stable release. The default.' },
  { value: 'early', label: 'Early', hint: 'Gets new releases first. Use it for a test collector or a site that can take the risk of a newer release.' },
];

export const CHANNEL_LABELS: Record<CollectorChannel, string> = { stable: 'Stable', early: 'Early' };

/** The one sentence that says what the choice means, shown wherever it is made. */
export const CHANNEL_EXPLANATION =
  'A collector upgrades itself to the latest release on its channel. Collectors on the early channel get new releases first.';

/**
 * How a collector reads in a pick list: its name and the release channel it follows, so a test collector on the early
 * channel is recognisable wherever one is chosen (#171). `shared` appends "(shared)" for a collector not bound to a client.
 */
export function collectorOptionLabel(c: { name: string; channel: CollectorChannel; clientId?: string | null }, showShared = false): string {
  return `${c.name} (${CHANNEL_LABELS[c.channel]})${showShared && !c.clientId ? ' (shared)' : ''}`;
}
